import topUSCities from 'src/seo/topUsCities.json'

export const DEFAULT_CURRENCY_CODE = "USD"
export const DEFAULT_DATE_POSTED = 'now-60d/d'
export const PROD_URL = `https://www.lifeshack.com`

export const env = () => {
    if (process.env.NEXT_PUBLIC_VERCEL_ENV) {
        return ({
            BASE_URL: `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`
        })
    } else {
        return ({
            BASE_URL: process.env.NEXT_PUBLIC_BASE_URL
        })
    }
}

export const BASE_URL = process.env.NEXT_PUBLIC_VERCEL_ENV ? `https://${process.env.NEXT_PUBLIC_VERCEL_URL}` : process.env.NEXT_PUBLIC_BASE_URL


// AutoApply
export const AutoApplyWaitlist = "https://forms.gle/8mRJDqWZVm9gTioG9"
export const AUTO_APPLY_BASIC= "BASIC_AUTO"
export const AUTO_APPLY_PRO= "PROFESSIONAL_AUTO"

export enum AUTO_NOTIFICATIONS {
    "AUTOAPPLY_ISACTIVE",
    "AUTOAPPLY_CANCELLED",
    "AUTOAPPLY_PAYMENTFAILED",
    "AUTOAPPLY_RENEWED"
}

export const AutoApplyPauseLink = process.env.NEXT_PUBLIC_VERCEL_ENV === "production" ? `${PROD_URL}/auto/pause` :  `${BASE_URL}/auto/pause`
export const AutoApplyResumeLink = process.env.NEXT_PUBLIC_VERCEL_ENV === "production" ? `${PROD_URL}/auto/resume` : `${BASE_URL}/auto/resume`

// API CODES
export const HTTP_OK = 200;
export const HTTP_BAD_REQUEST = 400;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
export const HTTP_NOT_FOUND = 404;
export const HTTP_METHOD_NOT_ALLOWED = 405;
export const HTTP_INTERNAL_SERVER_ERROR = 500;
export const HTTP_NOT_IMPLEMENTED = 501;
export const HTTP_BAD_GATEWAY = 502;
export const HTTP_SERVICE_UNAVAILABLE = 503;
export const HTTP_GATEWAY_TIMEOUT = 504;

export const termSlugs = [
    {
        slug: "software-engineer",
        searchTerm: "Software Engineer",
    },
    {
        slug: "designer",
        searchTerm: "Designer",
    },
    {
        slug: "marketing",
        searchTerm: "Marketing",
    },
    {
        slug: "sales",
        searchTerm: "Sales",
    },
    {
        slug: "customer-support",
        searchTerm: "Customer Support",
    },
    {
        slug: "design",
        searchTerm: "Design",
    },
    {
        slug: "product",
        searchTerm: "Product",
    },
    {
        slug: "finance",
        searchTerm: "Finance",
    },
    {
        slug: "legal",
        searchTerm: "Legal",
    },
    {
        slug: "people-ops",
        searchTerm: "People Ops",
    },
    {
        slug: "data-science",
        searchTerm: "Data Science",
    },
    {
        slug: "business-development",
        searchTerm: "Business Development",
    },
    {
        slug: 'administrative',
        searchTerm: 'Administrative'
    },
    {
        slug: "other",
        searchTerm: "Other",
    },
]

export const locationSlugs = [
    {
        slug: 'san-francisco',
        formattedLocation: 'San Francisco, CA USA',
        location: topUSCities.find(loc => loc.city === 'San Francisco')
    },
    {
        slug: 'new-york-city',
        formattedLocation: 'New York City, NY USA',
        location: topUSCities.find(loc => loc.city === 'New York City')
    },
    {
        slug: 'los-angeles',
        formattedLocation: 'Los Angeles, CA USA',
        location: topUSCities.find(loc => loc.city === 'Los Angeles')
    },
    {
        slug: 'seattle',
        formattedLocation: 'Seattle, WA USA',
        location: topUSCities.find(loc => loc.city === 'Seattle')
    },
    {
        slug: 'chicago',
        formattedLocation: 'Chicago, IL USA',
        location: topUSCities.find(loc => loc.city === 'Chicago')
    },
    {
        slug: 'houston',
        formattedLocation: 'Houston, TX USA',
        location: topUSCities.find(loc => loc.city === 'Houston')
    },
    {
        slug: 'philadelphia',
        formattedLocation: 'Philadelphia, PA USA',
        location: topUSCities.find(loc => loc.city === 'Philadelphia')
    },
    {
        slug: 'miami',
        formattedLocation: 'Miami, FL USA',
        location: topUSCities.find(loc => loc.city === 'Miami')
    },
    {
        slug: 'boston',
        formattedLocation: 'Boston, MA USA',
        location: topUSCities.find(loc => loc.city === 'Boston')
    }
]

export const jobPlatforms = [
    'greenhouse',
    'breezy',
    'lever',
    'workable',
    'applytojob',
    'comeet',
    'ashbyhq',
    'recruitee',
    'jobvite'
]